import type { Document } from './api';

// The server sends DocumentStatus enum names in PascalCase (Spec 096).
type Statused = Pick<Document, 'status'> | null | undefined;

export const isBinned = (document: Statused): boolean => document?.status === 'Deleted';

export const isInProcessing = (document: Statused): boolean =>
  document?.status === 'Uploading' || document?.status === 'Processing';

// Pipeline values are lowercase, the server's enum names PascalCase (Spec 096, 106).
// The parameter is wider than `Statused` because `UploadedDocument.status` is a plain string.
const FINISHED_STATUSES = new Set(['finished', 'completed', 'processed']);

export const isFinishedStatus = (document: { status?: string } | null | undefined): boolean =>
  FINISHED_STATUSES.has(document?.status?.toLowerCase() ?? '');
